// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"459":"5e7fbcea780f5ab0","662":"31ee232ce8226223"}[chunkId] + ".js";
};